<template>
	<a-space class="bread-wrap">
		<span>当前位置：</span>
		<a-breadcrumb>
			<a-breadcrumb-item><a href="/">系统主页</a></a-breadcrumb-item>
			<a-breadcrumb-item v-for="(item, index) in link" :key='index'><a :href="item.link">{{item.name}}</a></a-breadcrumb-item>
		</a-breadcrumb>
	</a-space>
</template>

<script>
	export default{
		name: 'HinaBreadCrumb',
		props: {
			link: {
				type: Array,
				default: () => []
			}
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.bread-wrap{
		padding: 16px 0;
		font-size: 16px;
	}
</style>